import { render, staticRenderFns } from "./PeopleCardForm.vue?vue&type=template&id=1e390683&scoped=true&"
import script from "./PeopleCardForm.vue?vue&type=script&lang=js&"
export * from "./PeopleCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e390683",
  null
  
)

export default component.exports